module.exports = __webpack_public_path__ + "media/efdab_1.0a.15026ae1.mp3";